export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Recaptcha.vue?vue&type=template&id=6c60f636&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/Recaptcha.vue?vue&type=template&id=6c60f636&
// module id = null
// module chunks = 